import React from 'react';
import { AvatarProps } from './types';
import {
  StyledAvatar,
  StyledAvatarImage,
  StyledAvatarPlaceholder,
  StyledAvatarPlaceholderText,
} from './styles';
import { AvatarSize } from './enums';

const hashHue = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h * 31 + s.charCodeAt(i)) % 360;
  }
  return Math.abs(h);
};

const getInitials = (name?: string): string => {
  if (!name) return '';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({
  size = AvatarSize.Small,
  src,
  alt,
  noBorder,
  placeholder,
}) => {
  const initials = getInitials(alt);
  const hue = alt ? hashHue(alt) : 0;
  const bg = alt ? `oklch(0.85 0.04 ${hue})` : undefined;
  const fg = alt ? `oklch(0.32 0.06 ${hue})` : undefined;

  return (
    <StyledAvatar {...{ size, noBorder }}>
      {src ? (
        <StyledAvatarImage {...{ src, alt }} />
      ) : (
        <>
          {placeholder || (
            <StyledAvatarPlaceholder
              $bg={bg}
              $color={fg}
            >
              <StyledAvatarPlaceholderText {...{ size }}>
                {initials || '·'}
              </StyledAvatarPlaceholderText>
            </StyledAvatarPlaceholder>
          )}
        </>
      )}
    </StyledAvatar>
  );
};

export default Avatar;
